import { hiringManagerCandidatesJobsConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";

//all mentors applied
export const get_suggested_candidates_hiring_manager_action =
  (data) => async (dispatch) => {
    dispatch({
      type: hiringManagerCandidatesJobsConstants.GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.hiringManager.allSuggestedCandidates,
        data
      );
      if (response.status) {
        dispatch({
          type: hiringManagerCandidatesJobsConstants.GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: hiringManagerCandidatesJobsConstants.GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

  //all applied candidates list
export const get_all_applied_candidates_list_action = () => async (dispatch) => {
  dispatch({
      type: hiringManagerCandidatesJobsConstants.ALL_APPLIED_CANDIDATES_LIST_REQUEST
  });
  try {
      const response = await axiosInstance.get(config.hiringManager.getAllAppliedCandidates)
      if (response.status) {
          dispatch({
              type: hiringManagerCandidatesJobsConstants.ALL_APPLIED_CANDIDATES_LIST_SUCCESS,
              payload: response.data,
          });
          return response.data;
      } else {
          return false;
      }
  } catch (e) {
      dispatch({
          type: hiringManagerCandidatesJobsConstants.ALL_APPLIED_CANDIDATES_LIST_FAILURE,
          payload: e.msg
      });
  }
};